import { useAtom } from 'jotai'

import { IconEyeOpen, IconEyeSlash, Button } from '@sequencehq/core-components'

import { showPreviewAtom } from '../Preview'

export const ButtonTogglePreview = () => {
  const [showPreview, setShowPreview] = useAtom(showPreviewAtom)

  return (
    <Button
      variant="secondary"
      onClick={() => {
        setShowPreview(prev => !prev)
      }}
      leadingIcon={
        showPreview ? (
          <IconEyeSlash color="inherit" />
        ) : (
          <IconEyeOpen color="inherit" />
        )
      }
      data-testid={
        showPreview
          ? 'header.button.hide-preview'
          : 'header.button.show-preview'
      }
    >
      {showPreview ? 'Hide preview' : 'Show preview'}
    </Button>
  )
}
